import { render, staticRenderFns } from "./Kostenbereiche.vue?vue&type=template&id=71b309ba&"
import script from "./Kostenbereiche.vue?vue&type=script&lang=ts&"
export * from "./Kostenbereiche.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports